import React from 'react';
import PageLayout from '../../components/Layout/PageLayout';

const UniverseIndex = props => {
  return <PageLayout>{props.location.pathname}</PageLayout>;
};

export default UniverseIndex;
